import {
    DEALERVIEWUSERMASTER_SUCCESS,
    DEALERVIEWUSERMASTER_FAILED,
    RESET_DEALERVIEWUSERMASTER,
    LOADING_DEALERVIEWUSERMASTER,
    NETWORK_ERROR_DEALERVIEWUSERMASTER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERVIEWUSERMASTER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERVIEWUSERMASTER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERVIEWUSERMASTER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERVIEWUSERMASTER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERVIEWUSERMASTER:
            return (state = initialState);
        default:
            return state;
    }
};
